<template>
  <div
    class="select"
    :class="classes"
  >
    <select
      v-model="fieldData.value"
      :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
    >
      <option
        :disabled="fieldDefinition.required || undefined"
        :value="null"
      >
        &mdash;
      </option>
      <template v-if="corpus">
        <option
          v-for="elementType in sortBy(corpus.types, (type) => type.display_name)"
          :key="elementType.slug"
          :value="elementType.slug"
        >
          {{ elementType.display_name }}
        </option>
      </template>
    </select>
  </div>
  <p
    class="help is-danger"
    v-for="(error, i) in [...localErrors, ...fieldData.errors]"
    :key="i"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { sortBy } from 'lodash'
import { computed } from 'vue'

import { useCorporaStore } from '@/stores'

import { type FieldModel, type FieldProps, ValidationError, defineValidator } from '.'

type Constraint = { type: 'element_type'; many: false }
const { fieldDefinition, corpusId } = defineProps<FieldProps<Constraint>>()
const fieldData = defineModel<FieldModel<Constraint>>({ required: true })

/*
 * Get the current corpus, assuming that corpora are already loaded since they are used by parent components,
 * and assuming there is always a corpus on the process.
 */
const corpus = corpusId ? useCorporaStore().corpora[corpusId] : null

const classes = computed(() => ({
  'is-danger': !fieldData.value.valid,
  'is-loading': fieldData.value.loading,
}))

const { localErrors } = defineValidator(fieldDefinition, fieldData.value, (slug: unknown) => {
  if (slug === null || corpus === null) return
  if (typeof slug !== 'string' || !corpus.types[slug])
    throw new ValidationError([`${slug} is not a valid element type`])
})
</script>
